// Copilot module interfaces — mirrors backend DTOs/ViewModels (SPEC 001)

// --- Enums (numeric values match backend C# enums) ---

export enum CopilotMessageRole {
  User = 1,
  Assistant = 2,
  Tool = 3,
  System = 4,
}

export enum CopilotToolKind {
  Read = 1,
  Write = 2,
}

export enum CopilotToolCallStatus {
  AwaitingConfirmation = 1,
  Confirmed = 2,
  Executed = 3,
  Failed = 4,
  Cancelled = 5,
  Expired = 6,
  Denied = 7,
}

// --- ViewModels ---

export interface CopilotConversation {
  id: string;
  title: string | null;
  startedAt: string;
  lastActivityAt: string;
}

export interface CopilotMessage {
  id: string;
  role: CopilotMessageRole;
  content: string | null;
  toolCallId: string | null;
  promptTokens?: number | null;
  completionTokens?: number | null;
  createdAt: string;
}

export interface CopilotToolCallPreviewField {
  label: string;
  value: string;
}

export interface CopilotToolCallPreview {
  summaryMarkdown: string;
  fields: CopilotToolCallPreviewField[];
}

export interface CopilotToolCallPreviewViewModel {
  id: string;
  batchId: string;
  toolName: string;
  toolVersion: string;
  kind: CopilotToolKind;
  preview: CopilotToolCallPreview;
  expiresAt: string;
}

export interface CopilotTurnResponse {
  newMessages: CopilotMessage[];
  pendingToolCalls: CopilotToolCallPreviewViewModel[];
  quotaRemaining: number;
}

export interface CopilotOnboarding {
  showIntroBubble: boolean;
}

export interface CopilotConversationDetail extends CopilotConversation {
  messages: CopilotMessage[];
  pendingToolCalls: CopilotToolCallPreviewViewModel[];
}
